<script setup lang="ts">
import useLocale from './helpers/use-locale';

export type MenuItems = {
  title: string;
  fontColor: string;
  eventName: string;
  icon?: string;
};

const modelValue = defineModel<boolean>();

type Props = {
  items?: MenuItems[];
};
defineProps<Props>();

type Emits = {
  (e: 'close'): void;
  (e: 'itemEvent', event: string): void;
  (e: string, ...args: any[]): void; // dynamic events
};
const emit = defineEmits<Emits>();
const { t } = useLocale();

const onUpdateModelValue = (value: boolean) => {
  if (value === false) {
    emit('close');
  }
};

const onItemEvent = (event: string) => {
  emit('itemEvent', event); // to be able to forward it further into the parent component
  emit(event);
};
</script>

<template>
  <v-bottom-sheet
    :model-value="modelValue"
    class="ma-2"
    @update:modelValue="onUpdateModelValue"
    style="margin-bottom: max(calc(12px + env(safe-area-inset-bottom, 0px)), 16px) !important"
  >
    <slot></slot>
    <v-list v-if="items && items.length > 0">
      <v-list-item
        v-for="(item, index) in items"
        :key="index"
        :value="index"
        class="text-center"
        @click="onItemEvent(item.eventName)"
      >
        <v-list-item-title :style="{ color: item.fontColor }">
          {{ item.title }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
    <v-list class="mt-2">
      <v-list-item class="text-center text-primary" @click="emit('close')">{{ t('components.cancel') }}</v-list-item>
    </v-list>
  </v-bottom-sheet>
</template>

<style scoped lang="scss">
.v-list-item {
  min-height: 51px;
  border-bottom: 1px solid #d1d1d1;

  &:last-child {
    border-bottom: none;
  }
}
.v-list {
  padding: 0;
  border-radius: 10px;
}
</style>
